let htmlHints = {};
const htmlHintsFormatted = {};

function formatHtmlHints() {
  if (htmlHints && htmlHints.length > 0) {
    for (let i = 0; i < htmlHints.length; i += 1) {
      htmlHintsFormatted[htmlHints[i].name] = htmlHints[i].value;
    }
  }
}

if (localStorage.company && localStorage.company !== 'null') {
  htmlHints = JSON.parse(localStorage.company).htmlHints || {};

  formatHtmlHints();
}

const partnerCompanyName = htmlHintsFormatted['webshop.partner.company-name'] || '';
const partnerVatNumber = htmlHintsFormatted['webshop.partner.vat-number'] || '';
const partnerRegNumber = htmlHintsFormatted['webshop.partner.registration-number'] || '';
const partnerPostalAddress = htmlHintsFormatted['webshop.partner.postall-address'] || '';
const partnerEmailAddress = htmlHintsFormatted['webshop.partner.email-address'] || '';

const country = (localStorage.company && JSON.parse(localStorage.company) && JSON.parse(localStorage.company).address.country) || 'UK';

const data = {
  // FOR UK !
  UK: `
<div class="content">
    <h4>1. Introduction</h4>
    <ol>
        <li>These terms and conditions (together with our privacy and cookies policy) set out the terms and conditions
            under which we provide access to our website and any mobile application through which you order products
            (together, the "website").
        </li>
        <li>By ordering through our website, you agree to be bound to these Terms and Conditions. You will be asked to
            give your express agreement to these terms and conditions before you place an order on our website.
        </li>
        <li>Any usage of the website is also subject to these Terms and Conditions.
        </li>
        <li>This document does not affect any statutory rights you may have as a consumer (such as rights under the
            Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013 or the Consumer
            Rights Act 2015).
        </li>
    </ol>
</div>

<div class="content">
    <h4>2. Interpretation</h4>
    <ol>
        <li>In these terms and conditions:
            <ul>
                <li>"we" means ${partnerCompanyName}; and</li>
                <li>"restaurant" means the restaurant with whom you place your order with; and</li>
                <li>"you" means customer or prospective customer,</li>
            </ul>
            and "us", "our" and "your" should be construed accordingly.
        </li>
    </ol>
</div>

<div class="content">
    <h4>3. Order process</h4>
    <ol>
        <li>The advertising of products on our website constitutes an "invitation to treat" rather than a contractual
            offer.
        </li>
        <li>No contract will come into force between you and us. We provide a way for you to review, select and place
            order for products to delivery or collection (=takeaway) restaurants. The legal contract for the supply and
            purchase of products is between you and the restaurant that you place your order with and we conclude the
            sale of products on behalf of, and agent for, the restaurants in all cases.
        </li>
        <li>To enter into a contract with the restaurant through our website, the following steps must be taken:
            <ul>
                <li>you must add the products you wish to purchase to your shopping cart, and then proceed to the
                    checkout;
                </li>
                <li>if you are a new customer, you can either continue the order as guest (without registration) or
                    create an account with and log in with that account;
                </li>
                <li>if you already have a registered account, you can enter your login details enabling to use your
                    pre-stored settings rather than having to enter them;
                </li>
                <li>depending on the above, you must select your preferred method of delivery and - if needed for the
                    selected order type - either enter or select your name, address, phone number and email address.
                </li>
                <li>optionally, you can request a certain delivery or collections/takeaway time; neither we nor the
                    restaurant guarantees that orders will be delivered or will be available at that time.
                </li>
                <li>confirm your order and your consent to the terms of this document;</li>
                <li>depending on the payment method you selected, you will - if necessary - be transferred to the
                    restaurants payment service provider's website, and the restaurant payment service provider will
                    handle your payment;
                </li>
                <li>we will then send you an initial acknowledgement; any confirmation page that you may see on the
                    website and any email confirmation that you may receive each confirm that you have a contract for
                    the sale of products with the restaurant but does not necessarily mean that your order will be
                    fulfilled by the restaurant. We encourage all restaurants to accept all orders and communicate any
                    rejection promptly. We will (generally by email) inform you as soon as reasonably practicable if a
                    restaurant rejects your order. Restaurants are entitled to reject orders at any time because of
                    weather conditions, unavailable ingredients, too many orders or any other reason. In doing so, they
                    will be in breach of their agreement with you and any payment made in respect of the order will be
                    returned to you in accordance with the paragraph 6.
                </li>
            </ul>
        </li>
        <li>You will have the opportunity to identify and correct input errors prior to making your order. The system
            will provide details within the error messages displayed in such cases.
        </li>
        <li>Once you have submitted your order - and (if applicable) your payment has been authorized - you are not
            entitled to change or cancel your order nor eligible for a refund. If you wish to change or cancel your
            order, you may contact the restaurant. There is no guarantee that the restaurant will be available nor that
            the restaurant will agree as they may have already started processing your order.
        </li>
    </ol>
</div>

<div class="content">
    <h4>4. Products</h4>
    <ol>
        <li>The products (their categorization, name, description, price, tax, photograph, video, ingredients,
            allergenic and heat warnings and any other detail) listed on our website are provided by the restaurant.
        </li>
        <li>The restaurant may periodically change the products available on our website, and neither the restaurant nor
            we do undertake to continue to supply any particular product or type of product.
        </li>
    </ol>
</div>

<div class="content">
    <h4>5. Prices</h4>
    <ol>
        <li>The product prices are quoted on our website.</li>
        <li>The restaurant will from time to time change the prices quoted on our website, but this will not affect
            contracts that have previously come into force.
        </li>
        <li>It is possible that prices on the website may be incorrectly quoted; accordingly, the restaurant will verify
            prices as part of the sale procedures so that the correct price will be notified to you before the contract
            comes into force.
        </li>
        <li>In addition to the price of the products, you may have to pay a delivery charge, which will be notified to
            you before the contract of sale comes into force.
        </li>
    </ol>
</div>

<div class="content">
    <h4>6. Payments</h4>
    <ol>
        <li>The available payment methods are defined by the restaurant.</li>
        <li>Payments are charged by the restaurant and are made using either:
            <ul>
                <li>credit or debit cards; or</li>
                <li>coupon; or</li>
                <li>in cash.</li>
            </ul>
        </li>
        <li>Unauthorized or unsuccessful payments in case of online payments stop the processing of the associated
            order. Such orders are not communicated to the restaurant.
        </li>
        <li>If you pay by credit or debit card, you may be required to show the card to the restaurant at the time of
            delivery or collection/takeaway as proof of identification.
        </li>
        <li>Cancellations and refunds follow the policy defined by the restaurant and are handled by the restaurant.
        </li>
    </ol>
</div>

<div class="content">
    <h4>7. Deliveries</h4>
    <ol>
        <li>The policies and procedures relating to the delivery of products are set out by the restaurant.</li>
        <li>Estimated times for delivery and collections/takeaway are only estimates and not guaranteed neither by us
            nor the restaurant.
        </li>
        <li>If your order includes any alcohol, tobacco or any other smoking product, you will be asked to provide proof
            of your age on delivery or collection of your order. If you are unable to provide this proof, the restaurant
            reserves the right not to complete the delivery of the alcohol, tobacco or any other smoking products to
            you.
        </li>
    </ol>
</div>

<div class="content">
    <h4>8. Distance contracts: cancellation right</h4>
    <ol>
        <li>Cancellations follow the restaurants cancellation policy and are handled by the restaurant.</li>
    </ol>
</div>

<div class="content">
    <h4>9. Warranties and representations</h4>
    <ol>
        <li>You warrant and represent to us that:
            <ul>
                <li>you are legally capable of entering into binding contracts;</li>
                <li>you have full authority, power and capacity to agree to these terms and conditions;</li>
                <li>all the information that you provide to us in connection with your order is true, accurate, complete
                    and non-misleading; and
                </li>
                <li>you are at least 18 years old; and</li>
                <li>you do not buy, or attempt to buy, alcohol, tobacco or any other smoking product on behalf of any
                    person who is under the age of 18;
                </li>
                <li>you will be able to take delivery of the products in accordance with these terms and condition and
                    the restaurants delivery policy.
                </li>
            </ul>
        </li>
        <li>We warrant and represent to you that:
            <ul>
                <li>we have the right to list the products on behalf of and as agent for the restaurants;
                </li>
                <li>we have no control over the restaurant, the quality of their products and services they provide,
                    their actions or omissions.
                </li>
            </ul>
        </li>
        <li>All of our warranties and representations relating to the supply of products are set out in these terms and
            conditions. To the maximum extent permitted by applicable law and subject to Section 10.1, all other
            warranties and representations are expressly excluded.
        </li>
    </ol>
</div>

<div class="content">
    <h4>10. Limitations and exclusions of liability</h4>
    <ol>
        <li>Nothing in these terms and conditions will:
            <ul>
                <li>limit or exclude any liability for death or personal injury resulting from negligence;</li>
                <li>limit or exclude any liability for fraud or fraudulent misrepresentation;</li>
                <li>limit any liabilities in any way that is not permitted under applicable law; or</li>
                <li>exclude any liabilities that may not be excluded under applicable law,</li>
                <li>and, if you are a consumer, your statutory rights will not be excluded or limited by these terms and
                conditions, except to the extent permitted by law.</li>
            </ul>
        </li>
        <li>The limitations and exclusions of liability set out in this Section 10 and elsewhere in these terms and
            conditions:
            <ul>
                <li>are subject to Section 10.1; and</li>
                <li>govern all liabilities arising under these terms and conditions or relating to the subject matter of
                    these terms and conditions, including liabilities arising in contract, in tort (including
                    negligence) and for breach of statutory duty, except to the extent expressly provided otherwise in
                    these terms and conditions.
                </li>
            </ul>
        </li>
        <li>We will not be liable to you in respect of any losses arising out of any event or events beyond our
            reasonable control.
        </li>
        <li>We will not be liable to you in respect of any business losses, including (without limitation):
            <ul>
                <li>loss of or damage to profits, income, revenue, use, production, anticipated savings, business,
                    contracts, commercial opportunities or goodwill; and
                </li>
                <li>loss or corruption of any data, database or software.
                </li>
            </ul>
        </li>
        <li>You accept that we have an interest in limiting the personal liability of our officers and employees and,
            having regard to that interest, you acknowledge that we are a limited liability entity; you agree that you
            will not bring any claim personally against our officers or employees in respect of any losses you suffer in
            connection with the website or these terms and conditions (this will not, of course, limit or exclude the
            liability of the limited liability entity itself for the acts and omissions of our officers and employees).
        </li>
        <li>We are not liable for any product related information as they are provided by the restaurant subject to
            Section 4, 5 and 6. If you are in doubt, please confirm with the restaurant directly before placing the
            order.
        </li>
        <li>We are not liable for providing any compensation to you on behalf of any restaurant.</li>
        <li>Our aggregate liability to you in respect of any contract under these terms and conditions shall not exceed
            the greater of:
            <ul>
                <li>£ 250; and</li>
                <li>the total amount paid and payable to us under the contract.</li>
            </ul>
        </li>
    </ol>
</div>

<div class="content">
    <h4>11. Cancellation and suspension of account</h4>
    <ol>
        <li>We may:
            <ul>
                <li>suspend your account; or</li>
                <li>cancel your account at any time in our sole discretion without notice or explanation.</li>
            </ul>
        </li>
    </ol>
</div>

<div class="content">
    <h4>12. Scope</h4>
    <ol>
        <li>These terms and conditions shall not constitute or effect any assignment or licence of any intellectual
            property rights.
        </li>
        <li>These terms and conditions shall not govern the licensing of works (including software and literary works)
            comprised or stored in products.
        </li>
        <li>These terms and conditions shall not govern the provision of any services by us or any third party in
            relation to the products.
        </li>
    </ol>
</div>

<div class="content">
    <h4>13. Variation</h4>
    <ol>
        <li>We may revise these terms and conditions from time to time by publishing a new version on our website.</li>
        <li>A revision of these terms and conditions will apply to contracts entered into at any time following the time
            of the revision, but will not affect contracts made before the time of the revision.
        </li>
    </ol>
</div>

<div class="content">
    <h4>14. Assignment</h4>
    <ol>
        <li>You hereby agree that we may assign, transfer, sub-contract or otherwise deal with our rights and/or
            obligations under these terms and conditions - providing, if you are a consumer, that such action does not
            serve to reduce the guarantees benefiting you under these terms and conditions.
        </li>
        <li>You may not without our prior written consent assign, transfer, sub-contract or otherwise deal with any of
            your rights and/or obligations under these terms and conditions.
        </li>
    </ol>
</div>

<div class="content">
    <h4>15. No waivers</h4>
    <ol>
        <li>No breach of any provision of a contract under these terms and conditions will be waived except with the
            express written consent of the party not in breach.
        </li>
        <li>No waiver of any breach of any provision of a contract under these terms and conditions shall be construed
            as a further or continuing waiver of any other breach of that provision or any breach of any other provision
            of that contract.
        </li>
    </ol>
</div>

<div class="content">
    <h4>16. Severability</h4>
    <ol>
        <li>If a provision of these terms and conditions is determined by any court or other competent authority to be
            unlawful and/or unenforceable, the other provisions will continue in effect.
        </li>
        <li>If any unlawful and/or unenforceable provision of these terms and conditions would be lawful or enforceable
            if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will
            continue in effect.
        </li>
    </ol>
</div>

<div class="content">
    <h4>17. Third party rights</h4>
    <ol>
        <li>The exercise of the parties' rights under a contract under these terms and conditions is not subject to the
            consent of any third party.
        </li>
    </ol>
</div>

<div class="content">
    <h4>18. Entire agreement</h4>
    <ol>
        <li>Subject to Section 10.1, these terms and conditions, together with our privacy and cookies policy, shall
            constitute the entire agreement between you and us and shall supersede all previous agreements between you
            and us.
        </li>
    </ol>
</div>

<div class="content">
    <h4>19. Law and jurisdiction</h4>
    <ol>
        <li>These terms and conditions shall be governed by and construed in accordance with English law.</li>
        <li>Any disputes relating to these terms and conditions shall be subject to the exclusive jurisdiction of the
            courts of England.
        </li>
    </ol>
</div>

<div class="content">
    <h4>20. Statutory and regulatory disclosures</h4>
    <ol>
        <li>We will not file a copy of these terms and conditions specifically in relation to each user or customer and,
            if we update these terms and conditions, the version to which you originally agreed will no longer be
            available on our website. We recommend that you consider saving a copy of these terms and conditions for
            future reference.
        </li>
        <li>These terms and conditions are available in the English language only.</li>
        <li>Our VAT number is ${partnerVatNumber}.</li>
    </ol>
</div>

<div class="content">
    <h4>21. Our details</h4>
    <ol>
        <li>This website is owned and operated by ${partnerCompanyName}.</li>
        <li>We are registered in England and Wales under registration number ${partnerRegNumber}, and our registered office is at
            ${partnerPostalAddress}.
        </li>
        <li>Our principal place of business is at ${partnerPostalAddress}.
        </li>
        <li>You can contact us:
            <ul>
                <li>by post, using the postal address given above;</li>
                <li>by email addressed to: <a href="mailto:${partnerEmailAddress}">${partnerEmailAddress}</a></li>
                <li>by telephone, on the contact number published on our website from time to time; or</li>
                <li>by email, using the email address published on our website from time to time.</li>
            </ul>
        </li>
    </ol>
</div>
`,
  // FOR AT !
  AT: `
<div class="content">
    <h4>1. Einführung</h4>
    <ol>
        <li>Diese Allgemeinen Geschäftsbedingungen (zusammen mit unserer Datenschutz- und Cookie-Richtlinie) legen die
            Allgemeinen Geschäftsbedingungen fest, unter denen wir Zugriff auf unsere Website und jede mobile Anwendung
            gewähren, über die Sie Produkte bestellen (im Folgenden, zusammen die "Website").
        </li>
        <li>Durch die Bestellung über unsere Website erklären sie sich mit diesen Allgemeinen Geschäftsbedingungen
            einverstanden. Sie werden gebeten, diesen Geschäftsbedingungen ausdrücklich zuzustimmen, bevor sie eine
            Bestellung auf unserer Website aufgeben.
        </li>
        <li>Jede Nutzung der Website unterliegt ebenfalls diesen Allgemeinen Geschäftsbedingungen.
        </li>
        <li>Dieses Dokument berührt nicht die gesetzlichen Rechte, die sie als Verbraucher haben.
        </li>
    </ol>
</div>

<div class="content">
    <h4>2. Bezeichnungen</h4>
    <ol>
        <li>In diesen Geschäftsbedingungen:
            <ul>
                <li>"wir" bedeutet ${partnerCompanyName}; und</li>
                <li>"Restaurant" bezeichnet das Restaurant, bei dem Sie Ihre Bestellung aufgeben; und</li>
                <li>"sie" bedeutet Kunde oder potenzieller Kunde,</li>
            </ul>
            und "wir", "unser" und "ihr" sollten entsprechend ausgelegt werden.
        </li>
    </ol>
</div>

<div class="content">
    <h4>3. Bestellprozess</h4>
    <ol>
        <li>Die Bewerbung unserer Produkte auf unserer Webseite stellen weder eine Aufforderung zur Offertstellung, noch
            ein Angebot, noch eine Empfehlung zum Erwerb, noch zum Tätigen irgendwelcher Transaktionen dar.
        </li>
        <li>Zwischen Ihnen und uns tritt kein Vertrag in Kraft. Wir bieten Ihnen die Möglichkeit, Produkte zu
            überprüfen, auszuwählen und zu bestellen, damit sie geliefert oder abgeholt (=zum Mitnehmen) werden. Der
            gesetzliche Vertrag über die Lieferung und den Kauf von Produkten kommt zwischen Ihnen und dem Restaurant
            zustande, bei dem sie Ihre Bestellung aufgeben, und wir schließen den Verkauf von Produkten in jedem Fall im
            Namen und in Vertretung der Restaurants ab.
        </li>
        <li>Um über unsere Website einen Vertrag mit dem Restaurant abzuschließen, müssen folgende Schritte unternommen
            werden:
            <ul>
                <li>sie müssen die Produkte, die Sie kaufen möchten, in Ihren Warenkorb legen und dann zur Kasse gehen;
                </li>
                <li>wenn Sie ein neuer Kunde sind, können sie entweder die Bestellung als Gast fortsetzen (ohne
                    Registrierung) oder ein Konto erstellen und sich mit diesem Konto anmelden;
                </li>
                <li>wenn Sie bereits ein registriertes Konto haben, können Sie Ihre Anmeldedaten eingeben, um Ihre
                    vorgespeicherten Einstellungen zu verwenden, anstatt sie eingeben zu müssen;
                </li>
                <li>abhängig davon müssen Sie Ihre bevorzugte Zustellart auswählen und - falls erforderlich für den
                    ausgewählten Auftragstyp - entweder ihren Namen, ihre Adresse, ihre Telefonnummer und ihre
                    E-Mail-Adresse eingeben oder auswählen.
                </li>
                <li>Optional können Sie eine bestimmte Liefer- oder Abhol- / Abholzeit anfordern. Weder wir noch das
                    Restaurant garantieren, dass Bestellungen geliefert werden oder zu diesem Zeitpunkt verfügbar sind.
                </li>
                <li>bestätigen sie Ihre Bestellung und ihre Zustimmung zu den Bestimmungen dieses Dokuments;</li>
                <li>abhängig von der von Ihnen ausgewählten Zahlungsmethode werden sie - falls erforderlich - auf die
                    Website des Zahlungsdienstleisters des Restaurants weitergeleitet, und der Zahlungsdienstleister des
                    Restaurants übernimmt ihre Zahlungsabwicklung;
                </li>
                <li>Wir senden ihnen dann eine erste Bestätigung. Jede Bestätigungsseite, die Sie möglicherweise auf der
                    Website sehen, und jede E-Mail-Bestätigung, die sie möglicherweise erhalten, bestätigen, dass Sie
                    einen Vertrag über den Verkauf von Produkten mit dem Restaurant haben, dies bedeutet jedoch nicht
                    unbedingt, dass Ihre Bestellung vom Restaurant ausgeführt wird. Wir empfehlen allen Restaurants,
                    alle Bestellungen anzunehmen und Ablehnungen unverzüglich mitzuteilen. Wir werden sie (in der Regel
                    per E-Mail) so schnell wie möglich informieren, wenn ein Restaurant ihre Bestellung ablehnt.
                    Restaurants sind berechtigt, Bestellungen aufgrund von Wetterbedingungen, nicht verfügbaren Zutaten,
                    zu vielen Bestellungen oder aus anderen Gründen jederzeit abzulehnen. Dabei verstoßen sie gegen ihre
                    Vereinbarung mit ihnen und jede Zahlung in Bezug auf die Bestellung wird ihnen gemäß Absatz 6
                    zurückerstattet.
                </li>
            </ul>
        </li>
        <li>Sie haben die Möglichkeit, Eingabefehler zu identifizieren und zu korrigieren, bevor sie Ihre Bestellung
            aufgeben. Das System wird Details in den in solchen Fällen erscheinenden Fehlermeldungen anzeigen.
        </li>
        <li>Sobald Sie Ihre Bestellung abgeschickt haben - und (falls zutreffend) ihre Zahlung autorisiert wurde - sind
            sie weder berechtigt, ihre Bestellung zu ändern oder zu stornieren, noch haben sie Anspruch auf eine
            Rückerstattung. Wenn sie Ihre Bestellung ändern oder stornieren möchten, können sie sich an das Restaurant
            wenden. Es gibt keine Garantie dafür, dass das Restaurant verfügbar ist oder dass das Restaurant zustimmt,
            da es möglicherweise bereits mit der Bearbeitung ihrer Bestellung begonnen hat.
        </li>
    </ol>
</div>

<div class="content">
    <h4>4. Produkte</h4>
    <ol>
        <li>Die auf unserer Website aufgeführten Produkte (deren Kategorisierung, Name, Beschreibung, Preis, Steuern,
            Foto, Video, Zutaten, Allergen- und Hitzewarnungen sowie sonstige Details) werden vom Restaurant
            bereitgestellt.
        </li>
        <li>Das Restaurant kann die auf unserer Website verfügbaren Produkte regelmäßig ändern, und weder das Restaurant
            noch wir verpflichten uns, weiterhin bestimmte Produkte oder Produkttypen zu liefern.
        </li>
    </ol>
</div>

<div class="content">
    <h4>5. Preise</h4>
    <ol>
        <li>Die Produktpreise sind auf unserer Website angegeben.</li>
        <li>Das Restaurant wird von Zeit zu Zeit die auf unserer Website angegebenen Preise ändern. Dies hat jedoch
            keine Auswirkungen auf Verträge, die zuvor in Kraft getreten sind.
        </li>
        <li>Es ist möglich, dass die Preise auf der Website falsch angegeben sind. Dementsprechend überprüft das
            Restaurant die Preise im Rahmen des Verkaufsverfahrens, sodass Sie vor Inkrafttreten des Vertrags über den
            korrekten Preis informiert werden.
        </li>
        <li>Zusätzlich zum Preis der Produkte müssen sie möglicherweise Lieferkosten bezahlen, die ihnen vor
            Inkrafttreten des Kaufvertrags mitgeteilt werden.
        </li>
    </ol>
</div>

<div class="content">
    <h4>6. Zahlungen</h4>
    <ol>
        <li>Die verfügbaren Zahlungsmethoden werden vom Restaurant festgelegt.</li>
        <li>Zahlungen werden vom Restaurant verrechnet und erfolgen entweder über:
            <ul>
                <li>Kredit-oder Debitkarten; oder</li>
                <li>Gutscheinen; oder</li>
                <li>in Bar.</li>
            </ul>
        </li>
        <li>Nicht autorisierte oder erfolglose Zahlungen bei Online-Zahlungen stoppen die Bearbeitung der zugehörigen
            Bestellung. Solche Bestellungen werden dem Restaurant nicht übermittelt.
        </li>
        <li>Wenn Sie mit Kredit- oder Debitkarte bezahlen, müssen Sie die Karte möglicherweise zum Zeitpunkt der
            Lieferung oder Abholung / Mitnahme als Identitätsnachweis dem Restaurant vorlegen.
        </li>
        <li>Stornierungen und Rückerstattungen richten sich nach den vom Restaurant festgelegten Richtlinien und werden
            vom Restaurant durchgeführt.
        </li>
    </ol>
</div>

<div class="content">
    <h4>7. Lieferungen</h4>
    <ol>
        <li>Die Richtlinien und Verfahren für die Lieferung von Produkten werden vom Restaurant festgelegt.</li>
        <li>Die geschätzten Liefer- und Abholzeiten sind nur Schätzungen und werden weder von uns noch vom Restaurant
            garantiert.
        </li>
        <li>Wenn Ihre Bestellung ein Produkt enthält das einem Altersnachweis vorraussetzt, werden Sie gebeten, bei
            Lieferung oder Abholung Ihrer Bestellung einen Altersnachweis vorzulegen. Wenn Sie diesen Nachweis nicht
            erbringen können, behält sich das Restaurant das Recht vor, die Lieferung der Produkte an Sie nicht
            abzuschließen.
        </li>
    </ol>
</div>

<div class="content">
    <h4>8. Fernverträge: Widerrufsrecht</h4>
    <ol>
        <li>Stornierungen folgen den Stornierungsbedingungen des Restaurants und werden vom Restaurant abgewickelt.</li>
    </ol>
</div>

<div class="content">
    <h4>9. Garantien und Zusicherungen</h4>
    <ol>
        <li>Sie garantieren und bestätigen uns gegenüber:
            <ul>
                <li>Sie sind rechtlich in der Lage, verbindliche Verträge abzuschließen;</li>
                <li>Sie haben die volle Autorität, Befugnis und Fähigkeit, diesen Geschäftsbedingungen zuzustimmen;</li>
                <li>Alle Informationen, die Sie uns im Zusammenhang mit Ihrer Bestellung zur Verfügung stellen, sind
                    wahr, genau, vollständig und nicht irreführend; und
                </li>
                <li>Sie sind mindestens 18 Jahre alt; und</li>
                <li>Sie kaufen oder versuchen nicht, Alkohol, Tabak oder andere Raucherprodukte für Personen zu kaufen,
                    die jünger als 18 Jahre sind.
                </li>
                <li>Sie können die Produkte gemäß diesen Geschäftsbedingungen und den Lieferrichtlinien des Restaurants
                    abholen bzw. entgegen zu nehmen.
                </li>
            </ul>
        </li>
        <li>Wir garantieren und vertreten Ihnen gegenüber:
            <ul>
                <li>Wir haben das Recht, die Produkte im Namen und als Vertreter der Restaurants aufzulisten;
                </li>
                <li>Wir haben keine Kontrolle über das Restaurant, die Qualität ihrer Produkte und Dienstleistungen,
                    ihre Handlungen oder Unterlassungen.
                </li>
            </ul>
        </li>
        <li>Alle unsere Garantien und Zusicherungen in Bezug auf die Lieferung von Produkten sind in diesen Allgemeinen
            Geschäftsbedingungen aufgeführt. Soweit gesetzlich zulässig und vorbehaltlich Ziffer 10.1, sind alle anderen
            Gewährleistungen und Zusicherungen ausdrücklich ausgeschlossen.
        </li>
    </ol>
</div>

<div class="content">
    <h4>10. Haftungsbeschränkungen und -ausschlüsse</h4>
    <ol>
        <li>Nichts in diesen Geschäftsbedingungen wird:
            <ul>
                <li>Beschränkung oder Ausschluss jeglicher Haftung für Tod oder Körperverletzung aufgrund von
                    Fahrlässigkeit;
                </li>
                <li>Beschränkung oder Ausschluss jeglicher Haftung für Betrug oder betrügerische Falschdarstellung;</li>
                <li>Verbindlichkeiten auf eine Weise begrenzen, die nach geltendem Recht nicht zulässig ist; oder</li>
                <li>jegliche Verbindlichkeiten ausschließen, die nach geltendem Recht nicht ausgeschlossen werden
                    dürfen,
                </li>
                <li>und wenn Sie Verbraucher sind, werden Ihre gesetzlichen Rechte durch diese Geschäftsbedingungen
                    nicht ausgeschlossen oder eingeschränkt, bis auf etwaige gesetzlich möglichen Ausnahmen.
                </li>
            </ul>
        </li>
        <li>Die in diesem Abschnitt 10 und an anderer Stelle in diesen Geschäftsbedingungen aufgeführten
            Haftungsbeschränkungen und -ausschlüsse:
            <ul>
                <li>unterliegen Abschnitt 10.1; und</li>
                <li>regeln alle Verbindlichkeiten, die sich aus diesen Geschäftsbedingungen ergeben oder sich auf den
                    Gegenstand dieser Geschäftsbedingungen beziehen, einschließlich Verbindlichkeiten, die sich aus
                    vertraglichen, unerlaubten Handlungen (einschließlich Fahrlässigkeit) und wegen Verletzung
                    gesetzlicher Pflichten ergeben, sofern in diesen Bedingungen nicht ausdrücklich etwas anderes
                    bestimmt ist.
                </li>
            </ul>
        </li>
        <li>Wir haften Ihnen gegenüber nicht für Verluste, die sich aus Ereignissen oder Ereignissen ergeben, die
            außerhalb unserer Kontrolle liegen.
        </li>
        <li>Wir haften Ihnen gegenüber nicht für geschäftliche Verluste, einschließlich (ohne Einschränkung):
            <ul>
                <li>Verlust oder Beschädigung von Gewinnen, Einnahmen, Einnahmen, Nutzung, Produktion, erwarteten
                    Einsparungen, Geschäften, Verträgen, Geschäftsmöglichkeiten oder Wohlwollen; und
                </li>
                <li>Verlust oder Beschädigung von Daten, Datenbanken oder Software.
                </li>
            </ul>
        </li>
        <li>Sie akzeptieren, dass wir ein Interesse daran haben, die persönliche Haftung unserer leitenden Angestellten
            und Mitarbeiter zu begrenzen und unter Berücksichtigung dieses Interesses erkennen Sie an, dass wir eine
            Gesellschaft mit beschränkter Haftung sind. Sie erklären sich damit einverstanden, dass Sie keine
            persönlichen Ansprüche gegen unsere leitenden Angestellten oder Mitarbeiter in Bezug auf Verluste geltend
            machen, die Sie im Zusammenhang mit der Website oder diesen Allgemeinen Geschäftsbedingungen erleiden (dies
            wird natürlich die Haftung der Gesellschaft mit beschränkter Haftung nicht einschränken oder ausschließen
            selbst für die Handlungen und Unterlassungen unserer leitenden Angestellten und Mitarbeiter).
        </li>
        <li>Wir haften nicht für produktbezogene Informationen, da diese vom Restaurant gemäß den Abschnitten 4, 5 und 6
            bereitgestellt werden. Wenn Sie Zweifel haben, bestätigen Sie dies bitte direkt vor der Bestellung mit dem
            Restaurant.
        </li>
        <li>Wir haften nicht dafür, Ihnen im Namen eines Restaurants Entschädigung zu gewähren.</li>
        <li>Unsere Gesamthaftung Ihnen gegenüber in Bezug auf Verträge unter diesen Geschäftsbedingungen darf den
            höheren Betrag von nicht überschreiten:
            <ul>
                <li>€ 250; und</li>
                <li>den Gesamtbetrag, der im Rahmen des Vertrags an uns gezahlt wurde oder zu zahlen wäre.</li>
            </ul>
        </li>
    </ol>
</div>

<div class="content">
    <h4>11. Kündigung und Sperrung des Kontos</h4>
    <ol>
        <li>Wir können:
            <ul>
                <li>Ihr Konto sperren; oder</li>
                <li>Sie können Ihr Konto jederzeit nach eigenem Ermessen ohne vorherige Ankündigung oder Erklärung
                    kündigen.
                </li>
            </ul>
        </li>
    </ol>
</div>

<div class="content">
    <h4>12. Umfang und Gültigkeit</h4>
    <ol>
        <li>Diese Allgemeinen Geschäftsbedingungen stellen keine Abtretung oder Lizenz von Rechten an geistigem Eigentum
            dar noch bewirken sie dies.
        </li>
        <li>Diese Allgemeinen Geschäftsbedingungen gelten nicht für die Lizenzierung von Werken (einschließlich Software
            und literarischen Werken), die in Produkten enthalten oder in diesen gespeichert sind.
        </li>
        <li>Diese Allgemeinen Geschäftsbedingungen regeln nicht die Erbringung von Dienstleistungen durch uns oder
            Dritte in Bezug auf die Produkte.
        </li>
    </ol>
</div>

<div class="content">
    <h4>13. Änderungen</h4>
    <ol>
        <li>Wir können diese Allgemeinen Geschäftsbedingungen von Zeit zu Zeit überarbeiten, indem wir eine neue Version
            auf unserer Website veröffentlichen.
        </li>
        <li>Eine Überarbeitung dieser Allgemeinen Geschäftsbedingungen gilt für Verträge, die zu einem beliebigen
            Zeitpunkt nach dem Zeitpunkt der Überarbeitung geschlossen werden, hat jedoch keine Auswirkungen auf
            Verträge, die vor dem Zeitpunkt der Überarbeitung abgeschlossen wurden.
        </li>
    </ol>
</div>

<div class="content">
    <h4>14. Zuteilung</h4>
    <ol>
        <li>Sie erklären sich hiermit einverstanden, dass wir unsere Rechte und / oder Pflichten unter diesen
            Geschäftsbedingungen abtreten, übertragen, untervergeben oder anderweitig behandeln können. Falls Sie
            Verbraucher sind, dient diese Maßnahme nicht dazu, die Rechte oder Garantien zu verringern, die Ihnen
            gemäß diesen Allgemeinen Geschäftsbedingungen zustehen.
        </li>
        <li>Ohne unsere vorherige schriftliche Zustimmung dürfen Sie Ihre Rechte und / oder Pflichten unter diesen
            Geschäftsbedingungen nicht abtreten, übertragen, untervergeben oder anderweitig behandeln.
        </li>
    </ol>
</div>

<div class="content">
    <h4>15. Keine Verzichtserklärung</h4>
    <ol>
        <li>Ein Verstoß gegen eine Bestimmung eines Vertrags unter diesen Geschäftsbedingungen wird nur mit
            ausdrücklicher schriftlicher Zustimmung der Partei, die nicht gegen das Gesetz verstößt, aufgehoben.
        </li>
        <li>Kein Verzicht auf einen Verstoß gegen eine Bestimmung eines Vertrags gemäß diesen Geschäftsbedingungen ist
            als weiterer oder fortgesetzter Verzicht auf einen anderen Verstoß gegen diese Bestimmung oder einen Verstoß
            gegen eine andere Bestimmung dieses Vertrags zu verstehen.
        </li>
    </ol>
</div>

<div class="content">
    <h4>16. Salvatorische Klausel</h4>
    <ol>
        <li>Wenn eine Bestimmung dieser Allgemeinen Geschäftsbedingungen von einem Gericht oder einer anderen
            zuständigen Behörde als rechtswidrig und / oder nicht durchsetzbar eingestuft wird, bleiben die anderen
            Bestimmungen in Kraft.
        </li>
        <li>Wenn eine rechtswidrige und / oder nicht durchsetzbare Bestimmung dieser Allgemeinen Geschäftsbedingungen
            rechtmäßig oder durchsetzbar wäre, wenn ein Teil davon ungültig werden würde, gilt dieser Teil als ungültig
            und der Rest der Bestimmung bleibt in Kraft.
        </li>
    </ol>
</div>

<div class="content">
    <h4>17. Rechte Dritter</h4>
    <ol>
        <li>Die Ausübung der Rechte der Parteien aus einem Vertrag unter diesen Geschäftsbedingungen bedarf nicht der
            Zustimmung Dritter.
        </li>
    </ol>
</div>

<div class="content">
    <h4>18. Gesamte Vereinbarung</h4>
    <ol>
        <li>Vorbehaltlich des Abschnitts 10.1 stellen diese Allgemeinen Geschäftsbedingungen zusammen mit unserer
            Datenschutz- und Cookie-Richtlinie die gesamte Vereinbarung zwischen Ihnen und uns dar und ersetzen alle
            vorherigen Vereinbarungen zwischen Ihnen und uns.
        </li>
    </ol>
</div>

<div class="content">
    <h4>19. Recht und Gerichtsbarkeit</h4>
    <ol>
        <li>Diese Allgemeinen Geschäftsbedingungen unterliegen österreichischem Recht und werden in Übereinstimmung mit
            diesem ausgelegt.
        </li>
        <li>Für alle Streitigkeiten im Zusammenhang mit diesen Geschäftsbedingungen sind ausschließlich die
            österreichischen Gerichte zuständig.
        </li>
    </ol>
</div>

<div class="content">
    <h4>20. Gesetzliche und behördliche Offenlegungen</h4>
    <ol>
        <li>Wir werden keine Kopie dieser Allgemeinen Geschäftsbedingungen speziell für jeden Benutzer oder Kunden
            einreichen. Wenn wir diese Allgemeinen Geschäftsbedingungen aktualisieren, ist die Version, der Sie
            ursprünglich zugestimmt haben, nicht mehr auf unserer Website verfügbar. Wir empfehlen Ihnen, eine Kopie
            dieser Allgemeinen Geschäftsbedingungen zum späteren Nachschlagen aufzubewahren.
        </li>
        <li>Diese Allgemeinen Geschäftsbedingungen sind nur in deutscher Sprache verfügbar.</li>
        <li>Unsere Umsatzsteuer-Identifikationsnummer lautet ${partnerVatNumber}.</li>
    </ol>
</div>

<div class="content">
    <h4>21. Unsere Daten</h4>
    <ol>
        <li>Diese Website gehört und wird betrieben von ${partnerCompanyName}.</li>
        <li>Wir sind in Österreich registriert unter ${partnerRegNumber} und unser Sitz ist in der
            ${partnerPostalAddress}.
        </li>
        <li>Unser Hauptgeschäftssitz befindet sich in ${partnerPostalAddress}.
        </li>
        <li>Sie können uns kontaktieren:
            <ul>
                <li>per Post unter Verwendung der oben angegebenen Postanschrift;</li>
                <li>per E-Mail adressiert an: <a href="mailto:${partnerEmailAddress}">${partnerEmailAddress}</a></li>
                <li>telefonisch unter der von Zeit zu Zeit auf unserer Website veröffentlichten Kontaktnummer; oder</li>
                <li>per E-Mail unter Verwendung der von Zeit zu Zeit auf unserer Website veröffentlichten E-Mail-Adresse.</li>
            </ul>
        </li>
    </ol>
</div>
`,
};

export default data[country];



// WEBPACK FOOTER //
// ./src/components/terms-and-privacy/terms.js